export const taxIdentifierFormatter = (nip: string | null | undefined): string => {
    if (!nip) return '-';
    if (nip.length != 10) return nip;
    return `${nip[0]}${nip[1]}${nip[2]} ${nip[3]}${nip[4]} ${nip[5]}${nip[6]} ${nip[7]}${nip[8]}${nip[9]}`;
};
